module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-notifications'), (this.$route.name !== undefined && _vm.lstRouteFront.includes(this.$route.name)) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('router-view'), (_vm.lstRouteFrontFooter.includes(this.$route.name)) ? _c('md-footer') : _vm._e()], 1) : _c('div', {
    staticClass: "wrapper",
    class: {
      'nav-open': _vm.navOpened
    }
  }, [(_vm.onHomePage()) ? _c('md-header') : _vm._e(), (!_vm.onHomePage() && _vm.onAuthenticated()) ? _c('sidebar', {
    attrs: {
      "open": _vm.navOpened
    }
  }) : _vm._e(), (!_vm.onHomePage() && _vm.onAuthenticated()) ? _c('div', {
    staticClass: "main-panel"
  }, [(!_vm.onHomePage() && _vm.onAuthenticated()) ? _c('navigation', {
    on: {
      "toggleSideBar": _vm.toggleSideBar
    }
  }) : _vm._e(), _c('router-view')], 1) : _c('router-view'), _c('div', {
    staticClass: "clearfix"
  }), (_vm.onHomePage()) ? _c('md-footer') : _vm._e(), (_vm.navOpened) ? _c('div', {
    staticClass: "close-layer",
    on: {
      "click": _vm.onCloseLayerClick
    }
  }) : _vm._e()], 1), _c('v-dialog')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9771bb54","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1630
// module chunks = 0